<div class="grid-view">
  @for (product of products(); track product) {
    <ui-product-card
      (addToShoppingListClicked)="addToShoppingList.emit($event)"
      [isPromotion]="highlightedProducts().includes(product)"
      [position]="$index+indexBase()"
      [product]="product"
      [showActions]="true"
      uiProductImpression
    ></ui-product-card>
  }
</div>
